import React, { useState, useEffect } from 'react';
import { db } from '../firebase';
import { collection, query, onSnapshot, doc, updateDoc, orderBy } from 'firebase/firestore';

const KargoOperasyon = () => {
  const [sekme, setSekme] = useState("HAZIRLANACAK");
  const [kargoFiltre, setKargoFiltre] = useState(null);
  const [siparisler, setSiparisler] = useState([]);

  useEffect(() => {
    const q = query(collection(db, "kargolar"), orderBy("tarih", "desc"));
    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const docs = [];
      querySnapshot.forEach((doc) => {
        docs.push({ id: doc.id, ...doc.data() });
      });
      setSiparisler(docs);
    });
    return () => unsubscribe();
  }, []);

  const filtrelenmişVeri = siparisler.filter(s => {
    const durumUyumu = s.durum === sekme;
    const kargoUyumu = kargoFiltre ? s.kargo === kargoFiltre : true;
    return durumUyumu && kargoUyumu;
  });

  const kargoyaVer = async (id) => {
    if(window.confirm("Bu sipariş kargo firmasına teslim edildi mi?")) {
      const docRef = doc(db, "kargolar", id);
      await updateDoc(docRef, { durum: "TESLIM_EDILEN", teslimTarihi: new Date().toISOString() });
    }
  };

  const geriAl = async (id) => {
    const docRef = doc(db, "kargolar", id);
    await updateDoc(docRef, { durum: "HAZIRLANACAK", teslimTarihi: null });
  };

  // --- YAZDIRMA FONKSİYONU ---
  const fişYazdır = (s) => {
    const printWindow = window.open('', '_blank');
    printWindow.document.write(`
      <html>
        <head>
          <title>KARGO ETİKETİ</title>
          <style>
            @page {
              size: 80mm auto; /* Termal kağıt genişliği 80mm, uzunluk içeriğe göre */
              margin: 0;
            }
            body { 
              font-family: 'Courier New', Courier, monospace; 
              width: 72mm; /* Yazdırılabilir alan */
              margin: 0 auto;
              padding: 5mm;
              background: white;
              color: black;
              text-transform: uppercase;
            }
            .label-border {
              border: 2px solid black;
              padding: 5px;
            }
            .header { 
              text-align: center; 
              font-size: 22px; 
              font-weight: bold; 
              border-bottom: 3px double black;
              padding-bottom: 5px;
              margin-bottom: 10px;
            }
            .section { 
              margin-bottom: 8px; 
              line-height: 1.2;
            }
            .title { font-size: 10px; font-weight: bold; text-decoration: underline; }
            .content { font-size: 14px; font-weight: bold; display: block; margin-top: 2px; }
            .items { 
              border-top: 1px dashed black; 
              margin-top: 10px; 
              padding-top: 5px; 
              font-size: 12px;
            }
            .footer { 
              margin-top: 15px; 
              text-align: center; 
              font-size: 18px; 
              font-weight: 900;
              border-top: 2px solid black;
              padding-top: 5px;
            }
            @media print {
              body { margin: 0; }
              .no-print { display: none; }
            }
          </style>
        </head>
        <body>
          <div class="label-border">
            <div class="header">${s.kargo}</div>
            
            <div class="section">
              <span class="title">ALICI:</span>
              <span class="content">${s.adSoyad}</span>
            </div>

            <div class="section">
              <span class="title">TELEFON:</span>
              <span class="content">${s.tel}</span>
            </div>

            <div class="section">
              <span class="title">ADRES:</span>
              <span class="content">${s.ilce} / ${s.koy}</span>
              <span class="content" style="font-size:12px;">${s.adres}</span>
            </div>

            <div class="items">
              <strong>İÇERİK:</strong><br/>
              ${s.aciklama}
            </div>

            <div class="footer">
              ÖDEME: ${s.tutar} TL
            </div>
          </div>
          <script>
            window.onload = function() { 
              window.print(); 
              setTimeout(() => { window.close(); }, 500);
            };
          </script>
        </body>
      </html>
    `);
    printWindow.document.close();
  };

  return (
    <div className="min-h-screen bg-black text-slate-200 p-4 md:p-8 font-sans uppercase">
      {/* ÜST BAŞLIK */}
      <div className="mb-8 flex justify-between items-end">
        <div>
          <h1 className="text-4xl font-black italic tracking-tighter text-white">KARGO <span className="text-blue-600">MERKEZİ</span></h1>
          <p className="text-slate-500 font-bold text-xs mt-1 tracking-widest">Operasyon ve Sevkiyat Yönetimi</p>
        </div>
      </div>

      {/* FİLTRELER */}
      <div className="flex flex-col md:flex-row gap-4 mb-6 items-center justify-between bg-slate-900/50 p-4 rounded-[30px] border border-slate-800">
        <div className="flex gap-2">
          <button onClick={() => setSekme("HAZIRLANACAK")} className={`px-6 py-3 rounded-2xl font-black italic text-[11px] transition-all ${sekme === "HAZIRLANACAK" ? 'bg-blue-600 text-white' : 'bg-slate-800 text-slate-500'}`}>📦 HAZIRLANACAKLAR</button>
          <button onClick={() => setSekme("TESLIM_EDILEN")} className={`px-6 py-3 rounded-2xl font-black italic text-[11px] transition-all ${sekme === "TESLIM_EDILEN" ? 'bg-emerald-600 text-white' : 'bg-slate-800 text-slate-500'}`}>✅ TESLİM EDİLENLER</button>
        </div>
        <div className="flex items-center gap-2 bg-black/40 p-1.5 rounded-2xl border border-white/5">
          <button onClick={() => setKargoFiltre(null)} className={`px-4 py-2 rounded-xl text-[10px] font-black ${!kargoFiltre ? 'bg-slate-700 text-white' : 'text-slate-500'}`}>HEPSİ</button>
          <button onClick={() => setKargoFiltre("DEVAY")} className={`px-4 py-2 rounded-xl text-[10px] font-black ${kargoFiltre === "DEVAY" ? 'bg-blue-600 text-white' : 'text-slate-500'}`}>DEVAY</button>
          <button onClick={() => setKargoFiltre("MAXPRESS")} className={`px-4 py-2 rounded-xl text-[10px] font-black ${kargoFiltre === "MAXPRESS" ? 'bg-red-600 text-white' : 'text-slate-500'}`}>MAXPRESS</button>
        </div>
      </div>

      {/* LİSTE */}
      <div className="space-y-3">
        {filtrelenmişVeri.length === 0 ? (
          <div className="py-20 text-center border-2 border-dashed border-slate-800 rounded-[40px]">
            <p className="text-slate-600 font-black italic tracking-widest uppercase">Görüntülenecek sipariş bulunamadı.</p>
          </div>
        ) : (
          filtrelenmişVeri.map((s) => (
            <div key={s.id} className="group bg-slate-900 border border-slate-800 p-5 rounded-[32px] flex flex-col md:flex-row items-center justify-between gap-6 hover:border-slate-600 transition-all">
              <div className="flex items-center gap-6 w-full md:w-1/4">
                <div className={`w-3 h-14 rounded-full ${s.kargo === 'DEVAY' ? 'bg-blue-600' : 'bg-red-600'}`}></div>
                <div>
                  <h3 className="text-white font-black text-xl italic leading-none">{s.adSoyad}</h3>
                  <p className="text-slate-500 text-[10px] font-bold mt-2 uppercase">📍 {s.ilce} / {s.koy}</p>
                </div>
              </div>

              <div className="flex-1 flex flex-wrap gap-2 w-full">
                <div className="bg-black/40 border border-white/5 px-4 py-2 rounded-xl text-slate-300 font-black text-[10px] uppercase">
                  {s.aciklama}
                </div>
              </div>

              <div className="flex items-center gap-3 w-full md:w-auto justify-end">
                <div className="px-4 text-center border-r border-slate-800 pr-6 mr-3">
                  <p className="text-[9px] font-black text-slate-500 uppercase mb-1">Tutar</p>
                  <p className="text-[11px] font-black italic text-emerald-500">{s.tutar} TL</p>
                </div>

                {sekme === "HAZIRLANACAK" ? (
                  <>
                    {/* YENİ YAZDIRMA BUTONU */}
                    <button onClick={() => fişYazdır(s)} className="bg-slate-800 hover:bg-slate-700 text-white p-4 rounded-2xl flex flex-col items-center min-w-[90px] transition-all">
                      <span className="text-xl">🖨️</span>
                      <span className="text-[8px] font-black mt-1 uppercase">Etiket</span>
                    </button>
                    <button onClick={() => kargoyaVer(s.id)} className="bg-emerald-600 hover:bg-emerald-500 text-white p-4 rounded-2xl flex flex-col items-center min-w-[110px] transition-all shadow-lg shadow-emerald-900/20">
                      <span className="text-xl">🚚</span>
                      <span className="text-[8px] font-black mt-1 uppercase">Verildi Yap</span>
                    </button>
                  </>
                ) : (
                  <button onClick={() => geriAl(s.id)} className="bg-slate-800 hover:bg-orange-600 text-white px-6 py-4 rounded-2xl font-black italic text-xs transition-all uppercase">
                    ↩️ Geri Al
                  </button>
                )}
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default KargoOperasyon;